import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const CheckoutService = createApi({
	reducerPath: "CheckoutService",
	tagTypes: "getOrder",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://allvehicles-backend.developer-ourbase-camp.com/api/user/orders/",
		prepareHeaders: (headers, { getState }) => {
			const reducers = getState();
			const token = reducers?.AuthReducer?.userToken;
			headers.set("authorization", token ? `Bearer ${token}` : "");
			return headers;
		},
	}),
	endpoints: (builder) => {
		return {
			getOrder: builder.query({
				query: () => {
					return {
						url: `my-orders`,
						method: "GET"
					};
				},
				providesTags: ["getOrder"],
			}),
			getOrderDetails: builder.query({
				query: (id) => {
					return {
						url: `my-order/${id}`,
						method: "GET",
					};
				},
				providesTags: ["getOrder"],
			}),
			checkout: builder.mutation({
				query: (data) => {
					return {
						url: `place_order`,
						method: "POST",
						body: data,
					};
				},
				invalidatesTags: ["getOrder"],
			}),

		};
	},
});
export const {
	useGetOrderQuery,
	useGetOrderDetailsQuery,
	useCheckoutMutation,

} = CheckoutService;
export default CheckoutService;